const setores = {
  PROTOCOLO: 'PROTOCOLO',
  JURIDICO: 'JURIDICO',
  DRF: 'DRF',
  DF1: 'DF1',
  DF3: 'DF3',
  COMISSAO_ILHA: 'COMISSAO_ILHA',
  DATGL: 'DATGL',
  PRESIDENCIA: 'PRESIDENCIA',
  CAF: 'CAF',
  CAS: 'CAS',
  CTT: 'CTT',
  DADR: 'DADR',
  CEP: 'CEP',
  DAF: 'DAF',
  CADR: 'CADR',
  DUF: 'DUF',
  DEO: 'DEO',
  DUA: 'DUA',
  DGRH: 'DGRH',
  DMP: 'DMP',
  PRODUTIVIDADE: 'PRODUTIVIDADE',
  RELATORIOS: 'RELATORIOS',
  FINANCEIRO: 'FINANCEIRO',
  GOVERNO: 'GOVERNO',
  PARAMETRIZACAO: 'PARAMETRIZACAO',
  GABINETE: 'GABINETE',
  GESTAO_SICARF: 'GESTAO_SICARF',
  CTRU: 'CTRU'
}

const setoresFormatado = {
  PROTOCOLO: 'Protocolo',
  JURIDICO: 'Jurídico',
  DRF: 'DRF - Diretoria de Recursos Fundiários',
  DF1: 'DF1 - Divisão Fundiária 1',
  DF1_VISTORIA: 'DF1 - Divisão Fundiária 1',
  DF1_DOCUMENTAL: 'DF1 - Divisão Fundiária 1',
  DF1_GEO: 'DF1 - Divisão Fundiária 1',
  DF1_VALIDACAO_GEO: 'DF1 - Divisão Fundiária 1',
  DF3: 'DF3 - Divisão Fundiária 3',
  DF3_VISTORIA: 'DF3 - Divisão Fundiária 3',
  DF3_DOCUMENTAL: 'DF3 - Divisão Fundiária 3',
  DF3_GEO: 'DF3 - Divisão Fundiária 3',
  DF3_VALIDACAO_GEO: 'DF3 - Divisão Fundiária 3',
  COMISSAO_ILHA: 'Comissão da Ilha',
  COMISSAO_ILHA_DOCUMENTAL: 'Comissão da Ilha',
  DATGL: 'DATGL - Divisão de Arquivo Técnico Gráfico e Literal',
  PRESIDENCIA: 'Presidência',
  CAF: 'CAF - Coordenação de Ação Fundiária',
  CAS: 'CAS - Comissão de Arrecadação Sumária',
  CTT: 'CTT - Comissão de Territórios Tradicionais',
  DADR: 'DADR - Diretoria de Assentamento e Desenvolvimento Rural',
  CEP: 'CEP - Coordenação de estudos e Projetos',
  DAF: 'DAF - Diretoria Administrativa Financeira',
  CADR: 'CADR - Coordenação de Assentamento e Desenvolvimento Rural',
  DUF: 'DUF - Diretoria da Unidade de Finanças',
  DEO: 'DEO - Divisão de Execução Orçamentária',
  DUA: 'DUA - Diretoria da Unidade Administrativa',
  DGRH: 'DGRH - Divisão de Gestão e Recursos Humanos',
  DMP: 'DMP - Divisão de Material e Patrimônio',
  PRODUTIVIDADE: 'Produtividade',
  RELATORIOS: 'Relatórios',
  FINANCEIRO: 'Financeiro',
  GOVERNO: 'Governo',
  PARAMETRIZACAO: 'Parametrização',
  GABINETE: 'Gabinete',
  GESTAO_SICARF: 'Gestão Sicarf',
  CTRU: 'CTRU - Cadastro e Titulação REURB'
}

export const nomesSetores = {
  PROTOCOLO: 'Protocolo',
  DRF: 'Diretoria de Recursos Fundiários',
  DF1: 'Divisão Fundiária 1',
  DF3: 'Divisão Fundiária 3',
  COMISSAO_ILHA: 'Comissão da Ilha',
  JURIDICO: 'Jurídico',
  DATGL: 'Divisão de Arquivo Técnico Gráfico e Literal',
  PRESIDENCIA: 'Presidência',
  CAS: 'Comissão de Arrecadação Sumária',
  CTT: 'Comissão de Territórios Tradicionais',
  DADR: 'Diretoria de Assentamento e Desenvolvimento Rural',
  CEP: 'Coordenação de estudos e Projetos',
  DAF: 'Diretoria Administrativa Financeira',
  CADR: 'Coordenação de Assentamento e Desenvolvimento Rural',
  DUF: 'Diretoria da Unidade de Finanças',
  DEO: 'Divisão de Execução Orçamentária',
  DUA: 'Diretoria da Unidade Administrativa',
  DGRH: 'Divisão de Gestão e Recursos Humanos',
  PRODUTIVIDADE: 'Produtividade',
  RELATORIOS: 'Relatórios',
  FINANCEIRO: 'Financeiro',
  GOVERNO: 'Governo',
  CAF: 'Coordenação de Ação Fundiária',
  DMP: 'Divisão de Material e Patrimônio',
  CPAD: 'Comissão Permanente de Análise de Documentos',
  EXTERNO: 'Externo',
  PARAMETRIZACAO: 'Parametrização',
  GABINETE: 'Gabinete',
  GESTAO_SICARF: 'Gestão Sicarf',
  CTRU: 'Cadastro e Titulação REURB'
}

export const setoresInformacao = [
  'PROTOCOLO',
  'DRF',
  'DF1',
  'DF3',
  'COMISSAO_ILHA',
  'JURIDICO',
  'DATGL',
  'PRESIDENCIA',
  'CAS',
  'CTT',
  'DADR',
  'CEP',
  'DAF',
  'CADR',
  'DUF',
  'DEO',
  'DUA',
  'DGRH',
  'CAF',
  'DMP'
]

export const setoresOrigemInformacao = [
  'DJ'
]

export default {
  setores,
  nomesSetores,
  setoresFormatado
}



// WEBPACK FOOTER //
// ./src/utils/ma/setor.js